import { NavigateFunction } from 'react-router-dom';
import { InterestsTypes } from 'src/enums/interests.enum';
import { RoutesEnum } from 'src/enums/route.enums';
import { LayoutViewType } from 'src/enums/user.enum';
import { routesTypes } from 'src/types';
import { urlHelper } from '.';

/*
Route handler
Takes url parameter to redirect
Takes params parameter to add search params along with url
Takes states parameter to add state value along with url
*/
export const handleRoute = (
  navigate: NavigateFunction,
  url: routesTypes.RoutesType,
  params?: Record<string, string>,
  states?: Record<string, any>,
) => {
  if (params && states) {
    return navigate(
      {
        pathname: url,
        search: urlHelper.addQueryParameters(params, ''),
      },
      { state: states },
    );
  }
  if (params) {
    return navigate({
      pathname: url,
      search: urlHelper.addQueryParameters(params, ''),
    });
  }
  if (states) {
    return navigate(url, { state: states });
  }

  return navigate(url);
};

/*
Find interest route handler
Takes interest type and layout type to redirect
Returns corresponding route for given interest type and layout type
*/
export const findInterestRoute = (
  type: InterestsTypes,
  layout: LayoutViewType,
): keyof typeof RoutesEnum | undefined => {
  if (layout === LayoutViewType.SC3_LAYOUT) {
    switch (type) {
      case InterestsTypes.Topic:
        return '/Topic';

      case InterestsTypes.Industry:
        return '/Industry';
      case InterestsTypes.Location:
        return '/Location';
      default:
        return undefined;
    }
  } else return '/Interests';
};
